module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_8011.9f502227.png";